module.exports = __webpack_public_path__ + "static/02-d915b6676af2c5b2d3b48a571a88de35.jpg";